document.addEventListener('turbolinks:render', () => {  
  if (window.adaEmbed) {
    window.adaEmbed.stop();
    window.adaEmbed.start({
      handle: 'betterment-cx',
    });
  }
});